import { render } from "./Update.vue?vue&type=template&id=7bd07f28"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
script.render = render

export default script